// SessionProvider.jsx
import React, { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = in loading
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const handleLogin = (token) => {
    localStorage.setItem("authToken", token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    sessionStorage.clear(); // 🔹 pulizia sessionStorage
    setIsAuthenticated(false);
    setLoading(false);
    navigate("/login", { replace: true }); // 🔹 sostituisce history ed evita loop
  };

  useEffect(() => {
    async function validateToken() {
      const token = localStorage.getItem("authToken");

      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        navigate("/login", { replace: true });
        return;
      }

      try {
        const response = await fetch("https://homelab.accesso-italiano.it/api/token", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-EXT-APP-KEY": "ai-external-app",
            "X-INT-APP-KEY": "ai-internal-app",
            "Authorization": `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error("Token non valido o scaduto");
        }

        setIsAuthenticated(true);
      } catch (err) {
        console.error("Errore validazione token:", err);
        localStorage.removeItem("authToken");
        sessionStorage.clear();
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
      } finally {
        setLoading(false);
      }
    }

    validateToken();
  }, [navigate]);

  return (
    <SessionContext.Provider value={{ isAuthenticated, loading, handleLogin, handleLogout }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
